import { useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { InputControlled } from 'components/UI/InputControlled/InputControlled';
import { yupResolver } from '@hookform/resolvers/yup';
import { loginFormSchema } from 'utils/form-validation-schema';
import { loginUser } from 'services/UserAccountService';

export const LoginForm = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(loginFormSchema),
  });
  const {
    formState: { isValid },
  } = methods;

  const onSubmitHandler = async (formData) => {
    setIsProcessing(true);

    const response = await loginUser(formData);
    const errorMessageText = response?.ErrorMessage;

    if (errorMessageText) {
      setErrorMessage(errorMessageText);
      setIsProcessing(false);
    } else {
      window.location.href = response?.RedirectUrl;
    }
  };

  const errorMessageSnippet = (
    <div className="callout-row">
      <div className="callout-container callout-error">
        <p>
          <strong>Sorry! </strong>
          <small>{errorMessage}</small>
        </p>
      </div>
    </div>
  );

  return (
    <FormProvider {...methods}>
      <form
        name="loginForm"
        noValidate="novalidate"
        onSubmit={methods.handleSubmit(onSubmitHandler)}
        data-testid="login-form"
      >
        <div className="box-bordered border-double">
          <div className="row">
            <div className="col-sm-12 col-md-8 col-md-offset-2">
              <h2 className="h5 hidden-xs">Already have an account?</h2>
              <p>Sign in now</p>
              <div className="form-group">
                <InputControlled
                  type="email"
                  id="inputEmailSignin"
                  labelText="Email address"
                  error={methods.formState.errors.inputEmailSignin}
                  appearFocusedOnLoad
                />
              </div>
              <div className="form-group">
                <InputControlled
                  type="password"
                  id="inputPasswordSignin"
                  labelText="Password"
                  error={methods.formState.errors.inputPasswordSignin}
                  appearFocusedOnLoad
                />
              </div>
              {errorMessage && errorMessageSnippet}
              <div className="form-group">
                <br />
                <button
                  type="submit"
                  className="btn btn-secondary btn-signin"
                  disabled={!isValid || isProcessing}
                  data-testid="sign-in-button"
                >
                  {isProcessing ? 'Processing...' : 'Sign in & continue'}
                </button>

                <p className="">
                  <a href="/my-account/forgot-password" className="link-bold link-forgot">
                    Forgot password
                  </a>
                </p>

                <div className="hidden-human-check">
                  <br />
                  <p>If this field is visible, please leave it blank.</p>
                  <input
                    type="text"
                    id="txtHumanCheck"
                    name="txtHumanCheck"
                    className="hidden-human-check ng-pristine ng-untouched ng-valid"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="text-float hidden-xs">or</div>
        </div>
      </form>
    </FormProvider>
  );
};
